import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";
import * as types from "../../sdk/types/api";
import { TIngredientPayload } from "../../sdk/utils/api/ingredients";

export const useCreateIngredient = (
    invalidQueryKeys: string | (string | number)[],
): UseMutationResult<types.IIngredient, unknown, TIngredientPayload> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<types.IIngredient, unknown, TIngredientPayload>({
        mutationFn: async (parameters: TIngredientPayload) => {
            if (!auth.token) {
                throw new Error("Cannot save without authorization token.");
            }
            return await api.Ingredients.create(parameters, auth.token);
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });
};
